export const dayIndexes = [1, 2, 3, 4, 5, 6, 0] as const;
